module.exports = __webpack_public_path__ + "static/media/export_icon.d31c71b2.svg";